// Author THQ
// Date 2025-04-08 13:29:31

import * as model from "@/model/em/ppe/PpeApplyScrapModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.PpeApplyScrap(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_EM_PPE_URL,
        callbackApi: process.env.VUE_APP_EM_PPE_URL + '/ppeApplyScrap/workflow/complete-feedback',
        processDefinitionKey: "ppe_apply_scrap",
        processBusinessData: Object
    })
    .withMutations({
        setProcessBusinessData(state, data) {
            state.processBusinessData = data
        }
    })
    .buildStore()
